<template>
  <!-- qcrode -->
  <div class="qrcode">
    <div 
    v-show="isShowCircle"
    class="circle"
    @click="closeCloak"
    :class="!isShow?'isDisplay':''"
    @mousedown="down"
    @mousemove="move"
    @mouseup="end"
    @touchstart="down"
    @touchmove="move"
    @touchend="end"
    ref="moveDiv">
      <span class="qrcode-icon iconfont"
      style="color: #1458D4">&#xe645;</span>
    </div>
    <cloak
    :code="code"
    :desc="desc"
    :isShow="isShow"
    @closeCloak="closeCloak"
    @pushPerc="setPerc"></cloak>
  </div>
</template>
<script>
import cloak from './cloak'
export default {
  props: ['code', 'desc', 'isShowCircle'],
  data () {
    return {
      isShow: false,
      flag: false,
      position: {
        x: 0,
        y: 0
      },
      dx: '',
      dy: '',
      endPosition: {
        xPum: '',
        yPum: ''
      },
      clientWidth: window.document.body.clientWidth
    }
  },
  computed: {
    divWidth () {
      return this.$refs.moveDiv.offsetWidth
    },
    divHeight () {
      return this.$refs.moveDiv.offsetHeight
    }
  },
  components: {
    cloak
  },
  methods: {
    closeCloak () {
      this.isShow = !this.isShow
    },
    setPerc (num) {
      if (num === 1) {
        this.$refs.moveDiv.style.opacity = ''
      } else if (num === 0) {
        this.$refs.moveDiv.style.opacity = ''
      } else {
        this.$refs.moveDiv.style.opacity = num
      }
    },
    moren (e) {
      e.preventDefault()
    },
    down (e) {
      this.flag = true
      let touch
      if (e.touches) {
        touch = e.touches[0]
      } else {
        touch = e
      }
      this.position.x = touch.clientX
      this.position.y = touch.clientY
      this.dx = this.$refs.moveDiv.offsetLeft
      this.dy = this.$refs.moveDiv.offsetTop
      this.$refs.moveDiv.style.transition = ''
    },
    move (e) {
      if (this.flag) {
        let touch
        if (e.touches) {
          touch = e.touches[0]
        } else {
          touch = e
        }
        this.endPosition.xPum = this.dx + touch.clientX - this.position.x
        this.endPosition.yPum = this.dy + touch.clientY - this.position.y
        // 判断 endPosition.xPum／endPosition.yPum 得正负值
        if (this.endPosition.xPum > this.clientWidth - this.divWidth) {
          this.endPosition.xPum = this.clientWidth - this.divWidth - 10
        }
        if (this.endPosition.xPum < 0) {
          this.endPosition.xPum = 10
        }
        if (this.endPosition.yPum > window.screen.height - this.divHeight) {
          this.endPosition.yPum = window.screen.height - this.divHeight - 10
        }
        if (this.endPosition.yPum < 0) {
          this.endPosition.yPum = 10
        }
        this.$refs.moveDiv.style.left = this.endPosition.xPum + 'px'
        this.$refs.moveDiv.style.top = this.endPosition.yPum + 'px'
        var passiveSupported = false
        try {
          var options = Object.defineProperty({}, 'passive', {
            get: function () {
              passiveSupported = true
            }
          })
          window.addEventListener('test', null, options)
        } catch (err) {}
        // 阻止页面的滑动默认事件
        // alert(passiveSupported)
        document.addEventListener('touchmove', this.moren(e), passiveSupported ? { passive: false } : false)
      }
    },
    end (e) {
      this.flag = false
      if (this.endPosition.xPum && this.endPosition.xPum <= this.clientWidth / 2 - this.divWidth / 2) {
        this.endPosition.xPum = 10
      }
      if (this.endPosition.xPum > this.clientWidth / 2 - this.divWidth / 2) {
        this.endPosition.xPum = this.clientWidth - this.divWidth - 10
      }
      this.$refs.moveDiv.style.transition = 'all 0.3s ease-in-out'
      this.$refs.moveDiv.style.left = this.endPosition.xPum + 'px'
      this.$refs.moveDiv.style.top = this.endPosition.yPum + 'px'
    }
  }
}
</script>
<style scoped lang='scss'>

.qrcode {
  .circle {
    width: 64px;
    height: 64px;
    box-sizing: border-box;
    padding: 14px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 6px rgba(7,17,27,.1);
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    position: fixed;
    right: 10px;
    bottom: 15%;
    z-index: 9999;
    opacity: 0;
    &.isDisplay {
      opacity: 1;
    }
    .qrcode-icon {
      font-size: 29px;
    } 
  }
}
</style>
